// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3woW_","info":"Note_info__2pEZM","note":"Note_note__SM4Mk","actions":"Note_actions__htRZ0"};